import Axios from 'axios'
import {currencyUrls} from '../urls'
import router from '../../../router'

export default {
  deactivate_payment_option (context, data) {
    Axios.patch(currencyUrls.deActivatePaymentOption, data).then((response) => {
      context.dispatch('get_payment_platforms')
    })
  },
  activate_payment_option (context, data) {
    Axios.patch(currencyUrls.activatePaymentOption, data).then((response) => {
      context.dispatch('get_payment_platforms')
    })
  },
  get_all_currencies (context) {
    Axios.get(currencyUrls.getAllCurrencies).then(function (response) {
      context.commit('GET_ALL_CURRENCIES', response.data)
    })
  },
  get_all_currency_types (context) {
    Axios.get(currencyUrls.getAllCurrencyTypes).then(function (response) {
      context.commit('GET_ALL_CURRENCY_TYPE', response.data)
    })
  },
  get_active_exchanges (context) {
    Axios.get(currencyUrls.getAllActiveCurrency).then(function (response) {
      context.commit('GET_EXCHANGES', response.data)
    })
  },
  get_currencies (context, publicId) {
    Axios.get(currencyUrls.getCurrencies + publicId).then(function (response) {
      context.commit('GET_CURRENCIES', response.data)
    })
  },
  get_deleted_currencies (context) {
    Axios.get(currencyUrls.getDeletedCurrency).then(function (response) {
      context.commit('GET_DELETED_CURRENCIES', response.data)
    })
  },
  get_currency (context, publicId) {
    Axios.get(currencyUrls.getCurrency + publicId).then(function (response) {
      context.commit('GET_CURRENCY', response.data)
    })
  },
  get_all_exchanges (context) {
    Axios.get(currencyUrls.getAllExchanges).then(function (response) {
      context.commit('GET_EXCHANGES', response.data)
    })
  },
  get_current_currency (context) {
    Axios.get(currencyUrls.getCurrentCurrency).then(function (response) {
      context.commit('GET_CURRENCY', response.data)
    })
  },
  post_exchange (context, data) {
    Axios.post(currencyUrls.postExchange, data).then(function () {
      context.dispatch('get_all_exchanges')
      router.push({
        name: 'CurrencyReport'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  post_currency (context, data) {
    Axios.post(currencyUrls.postCurrency, data).then(function () {
      context.dispatch('get_all_currencies')
      router.push({
        name: 'UpdateCurrency'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_currency (context, data) {
    Axios.post(currencyUrls.postCurrency, data).then(function () {
      context.dispatch('get_all_currencies')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_currency (context, publicId) {
    Axios.delete(currencyUrls.deleteCurrency + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_CURRENCIES', response.data)
      router.push({
        name: 'Module.DeletedCurrencies'
      })
    })
  },
  restoreCurrency (context, publicId) {
    Axios.get(currencyUrls.restoreCurrency + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CURRENCIES', response.data)
      router.push({
        name: 'Module.Currencies'
      })
    })
  },

  get_currency_exchange_rate_by_date (context, data) {
    Axios.post(currencyUrls.getCurrencyExchangeRateByDate, data).then(function (response) {
      context.commit('GET_CURRENCY_RATE_BY_DATE', response.data)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
}
